import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import createCaughtAsyncThunk from '~/utils/create-action/create-caught-async-thunk';
import ChangeLogAPI from '~/api/changelog-api';
import * as localStorageUtils from '~/utils/local-storage-utils/local-storage-utils';
import { getDateOneMonthAgo } from '~/domain/changelog/utils/getDateOneMonthAgo';
import { ChangeLogItem, defaultState } from './ChangeLogState';

export const loadChangeLog = createCaughtAsyncThunk<ChangeLogItem[]>(
  'loadChangeLog',
  async (_args, thunkAPI) => {
    let items: ChangeLogItem[] = [];
    const { data } = await thunkAPI.dispatch(ChangeLogAPI.endpoints.getChangeLogItems.initiate());
    items = data!;

    return [...items].sort((a, b) => (a.date > b.date ? -1 : 1));
  }
);

const slice = createSlice({
  name: 'changelog',
  initialState: defaultState,
  reducers: {
    toggleModalOpen: (state) => {
      state.isModalOpen = !state.isModalOpen;
    },
    setLastReadChangeLogItemDate: (state, action: PayloadAction<{ date: string }>) => {
      state.lastReadChangeLogItemDate = action.payload.date;
      localStorageUtils.setLastReadChangeLogItemDate(action.payload.date);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadChangeLog.pending, (state) => {
        state.isLoading = true;
        state.items = [];
        delete state.error;
      })
      .addCase(loadChangeLog.fulfilled, (state, action) => {
        state.isLoading = false;
        state.items = action.payload;
        const minDate = getDateOneMonthAgo();
        const hasUnreadItems = state.items.some(
          (item) => item.date > state.lastReadChangeLogItemDate && item.date > minDate
        );
        state.isModalOpen = hasUnreadItems;
      })
      .addCase(loadChangeLog.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { toggleModalOpen, setLastReadChangeLogItemDate } = slice.actions;
export default slice.reducer;
